import React, { ReactNode } from "react";

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    children: ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;

    return (
        // Modal overlay with backdrop blur
        <div 
            className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50"
            onClick={onClose}
        >
            {/* Modal container with responsive sizing */}
            <div 
                className="
                    relative 
                    w-full 
                    max-w-[95%] md:max-w-[800px]
                    max-h-[90vh] 
                    bg-white 
                    rounded-2xl 
                    shadow-lg 
                    flex 
                    flex-col
                    overflow-hidden
                    transform
                    transition-all
                    scale-95 hover:scale-100
                    duration-200
                "
                onClick={(e) => e.stopPropagation()}
            >
                {/* Close button with improved touch target */}
                <button 
                    className="
                        absolute 
                        top-2 
                        right-2 
                        w-8 
                        h-8 
                        flex 
                        items-center 
                        justify-center 
                        rounded-full 
                        text-gray-500 
                        hover:bg-gray-100 
                        transition-colors
                        duration-200
                    "
                    onClick={onClose}
                    aria-label="Close modal"
                >
                    <span className="text-2xl leading-none">&times;</span>
                </button>

                {/* Scrollable content area */}
                <div className="
                    flex-1 
                    overflow-y-auto 
                    overscroll-contain
                    scrollbar-none       /* Tailwind scrollbar plugin class */
                    [-ms-overflow-style:none]  /* Hide scrollbar in IE and Edge */
                    [scrollbar-width:none]     /* Hide scrollbar in Firefox */
                    [&::-webkit-scrollbar]:hidden  /* Hide scrollbar in Chrome/Safari */
                ">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Modal;